import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';
import PlayVideoComponent from '../../PlayVideoComponent';

export function SeoCard({ card }) {
  const { title, icon, path } = card;

  const cancelOpenPage = (e) => {
    e.preventDefault();
  };

  return (
    <Link to={path} className={Styles['seo-card']}>
      <div className={Styles.icon}>
        <img src={icon} alt={title} />
      </div>
      <span className={Styles.name}>{title}</span>
      <div onClick={cancelOpenPage}>
        {
          title === 'Stocks'
          && (
          <PlayVideoComponent
            videoLink="https://cityfalcon.wistia.com/medias/k55d2nkan7"
            videoLinkMobile="https://cityfalcon.wistia.com/medias/k55d2nkan7"
            additionalStyles={Styles['seo-card-play-button-stocks']}
            tooltipAdditionalContentStyle={Styles['seo-card-play-button-stocks-tooltip']}
          />
          )
        }
        {
          title === 'Cryptocurrencies'
          && (
          <PlayVideoComponent
            videoLink="https://cityfalcon.wistia.com/medias/nvrijpors2"
            videoLinkMobile="https://cityfalcon.wistia.com/medias/nvrijpors2"
            additionalStyles={Styles['seo-card-play-button']}
            tooltipAdditionalContentStyle={Styles['seo-card-play-button-stocks-tooltip']}
          />
          )
        }
        {
          title === 'Ratings & Research Firms'
          && (
          <PlayVideoComponent
            videoLink="https://cityfalcon.wistia.com/medias/t5qc3w8zuw"
            videoLinkMobile="https://cityfalcon.wistia.com/medias/o29qf5n8sd"
            additionalStyles={Styles['seo-card-play-button']}
            tooltipAdditionalContentStyle={Styles['seo-card-play-button-stocks-tooltip']}
          />
          )
        }
      </div>
    </Link>
  );
}

SeoCard.propTypes = {
  card: PropTypes.shape({
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default withComponentName(SeoCard);
